import axios from 'axios';
import { cacheService } from './CacheService';

export const getGitaHeaders = () => ({
  'x-rapidapi-key': process.env.REACT_APP_RAPID_API_KEY || '75a490c320msh7e10a98ddf71ee6p1bca00jsnaeee1f34c433',
  'x-rapidapi-host': process.env.REACT_APP_RAPID_API_HOST || 'bhagavad-gita3.p.rapidapi.com',
});

export const isAbortError = (error) =>
  error?.name === 'AbortError' ||
  error?.name === 'CanceledError' ||
  error?.code === 'ERR_CANCELED' ||
  axios.isCancel?.(error);

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://bhagavad-gita3.p.rapidapi.com/v2',
  headers: {
    'Content-Type': 'application/json',
    ...getGitaHeaders()
  },
});

class ApiService {
  /**
   * @param {string} endpoint
   * @param {Object} [options]
   * @param {boolean} [options.skipCache]
   * @param {number} [options.cacheExpiry]
   * @param {AbortSignal} [options.signal]
   * @param {Object} [options.params]
   */
  async request(endpoint, options = {}) {
    const { skipCache = false, cacheExpiry, signal, ...axiosOptions } = options;

    if (!skipCache) {
      const cachedData = cacheService.get(endpoint, axiosOptions.params);
      if (cachedData) {
        return cachedData;
      }
    }

    try {
      const response = await api(endpoint, { ...axiosOptions, signal });

      if (!skipCache) {
        cacheService.set(endpoint, response.data, axiosOptions.params, cacheExpiry);
      }

      return response.data;
    } catch (error) {
      if (!isAbortError(error)) {
        console.error('API request failed:', error);
      }
      throw error;
    }
  }

  get(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'GET' });
  }

  post(endpoint, data, options = {}) {
    return this.request(endpoint, { ...options, method: 'POST', data });
  }

  put(endpoint, data, options = {}) {
    return this.request(endpoint, { ...options, method: 'PUT', data });
  }

  delete(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'DELETE' });
  }

  clearCache(endpoint, params) {
    cacheService.clear(endpoint, params);
  }
}

export const apiService = new ApiService();
